import React from 'react'
import { Region } from '@enonic/react-components'
import type { CountyLayoutRegions } from './county-layout.d'
import CountyMenu, { type CountyMenuLink } from '../../../react4xp/components/CountyMenu'
import Campaign from '../../../react4xp/components/Campaign'
import { type CampaignProps } from '../../../react4xp/components/Campaign'

interface CountyLayoutProps {
  currentCountyLabel: string
  currentCountyHref: string
  currentCountyTarget: '_self' | '_blank'
  countySubMenu: CountyMenuLink[]
  countyMenu: CountyMenuLink[]
  campaign: CampaignProps
  regions: CountyLayoutRegions
  showCampaign: boolean
}

function CountyLayout({
  currentCountyLabel,
  currentCountyHref,
  currentCountyTarget,
  countyMenu,
  countySubMenu,
  campaign,
  regions,
  showCampaign
}: CountyLayoutProps) {
  return (
    <>
      <CountyMenu
        currentCountyLabel={currentCountyLabel}
        currentCountyHref={currentCountyHref}
        currentCountyTarget={currentCountyTarget}
        countyItems={countySubMenu}
        menuItems={countyMenu}
      />

      {showCampaign && (
        <Campaign
          view='with-image'
          background='dark'
          heading={campaign.heading}
          description={campaign.description}
          header_image={campaign.header_image}
        />
      )}

      <Region name={regions.content.name} regionData={regions.content} />
    </>
  )
}

export default (props) => <CountyLayout {...props} />


